import { Observable } from "./observable.js";

function syncLocalStorage(key: string, obs: Observable<any>) {
    const lsVal = localStorage.getItem(key);

    if (lsVal) {
        obs.broadcast(lsVal);
    }

    obs.subscribe((val) => {
        localStorage.setItem(key, val);
    });
}

// Theme
type BDTheme = "dark" | "light";
let initialTheme: BDTheme = "light";
if (
    window.matchMedia &&
    window.matchMedia("(prefers-color-scheme: dark)").matches
) {
    initialTheme = "dark";
}
export const $theme = new Observable<BDTheme>(initialTheme);
syncLocalStorage("bd-theme", $theme);
